import { HttpClient } from '@angular/common/http';
import { Component, NgZone, OnInit, ViewChild, AfterViewInit, Input, ElementRef } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from 'src/app/services/data.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.sass']
})

export class UsersComponent implements OnInit {
  minPw = 6;
  users: any;
  email: string;
  usersListSubs: Subscription;
  usersList: User[];
  params: User[];
  isList: boolean = true;
  isNew: boolean = true;
  private routeSub: Subscription;
  userForm: FormGroup;
  filterForm: FormGroup;
  pageEvent: PageEvent;
  modification_date: string;
  creation_date: string;
  readOnly: boolean = false;
  pageSize: number = 100;
  pageIndex: number = 0;
  totalItems: any;
  role: any;
  firstTime: boolean = true

  displayedColumns: string[] = ['name', 'email', 'role', 'actions'];
  dataSource: any = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;

  searchForm: FormGroup

  showUsersProgressBar: boolean = false;

  constructor(
    public dataService: DataService,
    private http: HttpClient,
    public firebase: AngularFireAuth,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    private snackbar: MatSnackBar
  ) { }

  public getUsers() {
    this.usersListSubs = this.dataService
      .getUsers('')
      .subscribe(res => {
        this.users = res;
      },
        console.error
      );
  }

  ngOnInit() {
    this.dataService.getRole().subscribe(res => {
      this.role = res;
      if ((res != 'superadmin') && (res != 'admin')){
        this.router.navigate(['/welcome']);
      }

    });
    this.userForm = this.formBuilder.group({
      id: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      // last_name: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      phone: new FormControl(''),
      role: new FormControl('', Validators.required),
      manager: new FormControl('')
      // password: ['', [Validators.required, Validators.minLength(this.minPw)]],
      // password2: ['', [Validators.required]]
    });

    this.filterForm = this.formBuilder.group({
      role: new FormControl('', Validators.required)
    });

    this.searchForm =  this.formBuilder.group({
      search: new FormControl('')
    });
    
    var params = {};
    params['page'] = 1
    params['size'] = this.pageSize
    params['search'] = '';
    params['role'] = '';

    if(localStorage.getItem('users'))
    {
      this.firstTime = false

      let data = JSON.parse(localStorage.getItem('users'))

      this.pageSize = data.pageSize
      this.pageIndex = data.page-1

      params['page'] = this.pageIndex+1
      params['size'] = this.pageSize
      params['search'] = data.search
      params['role'] = data.role

      this.filterForm.controls['role'].setValue(params['role'] != undefined ? params['role'] : '')
      this.searchForm.controls['search'].setValue(params['search'] != undefined ? params['search'] : '')

      if(params['search'] != '' && params['search'] != undefined)
      {
        this.dataService.getUsers(params).pipe(
          map((tableData: User) => (
            this.dataSource = tableData
          )
          )
        ).subscribe(() => {
          this.dataSource.sort((a, b) => a.name.localeCompare(b.name))
          this.showUsersProgressBar = false
        }
        )
    
        this.dataService.getTotalUsers(params).pipe(
          map((totalItems) => this.totalItems = totalItems)
        ).subscribe()
      }
    }
      

    this.routeSub = this.route.params.subscribe(params => {
      if (params.id) {
        this.isList = false;
        this.showUsersProgressBar = true

        if (params.id != 'new') {
          this.isNew = false;
          this.usersListSubs = this.dataService
            .getUser(params.id)
            .subscribe(res => {
              this.users = res;
              if ((this.users.role == 'superadmin') && (this.role == 'admin')){
                this.router.navigateByUrl(`/users`);
                this.translate.get('alerts.no_permissions_required_to_edit').subscribe((res: string) => {
                  this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
                  return false;
                })
                
              }
              this.userForm.controls["id"].setValue(this.users['id']);
              this.userForm.controls["name"].setValue(this.users['name']);
              this.userForm.controls["phone"].setValue(this.users['phone']);
              // this.userForm.controls["last_name"].setValue(this.users.last_name);
              this.userForm.controls["email"].setValue(this.users.email);
              this.readOnly = true;

              this.userForm.controls["role"].setValue(this.users.role);
              this.userForm.controls["manager"].setValue(this.users.manager_key);
              this.creation_date = this.users.creation_date;
              this.modification_date = this.users.modification_date;
            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }
      }
      else {
        this.isList = true;
      }

      
      //this.codeId = params['id'];
    });
  }


  goTo(userID: string) {
    let data = {}
    data['page'] = this.paginator.pageIndex+1
    data['pageSize'] = this.paginator.pageSize
    data['role'] = this.filterForm.controls["role"].value
    data['search'] = (<HTMLInputElement>document.getElementById("input")).value
    localStorage.setItem('users', JSON.stringify(data))
    this.router.navigateByUrl(`user/${userID}`);
  }

  toggle_notifications(userID: string){
    this.dataService.toggle_notifications(userID).subscribe(res3 => {
      if (res3.status == 'ok') {
        this.translate.get('alerts.toggle_user_ok').subscribe(res4 => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
          this.applyFilter()
        })
      }
      else {
        this.translate.get('alerts.toggle_user_error').subscribe(res4 => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000, panelClass: "error-snackbar" })
        })
      }
    })
  }

  // resetPassword(userID: string){
  //   let trans = this.translate
  //   this.usersListSubs = this.dataService
  //     .getUser(userID)
  //     .subscribe(res => {
  //       this.firebase.sendPasswordResetEmail(res['email']).then(function() {
  //         // Email send
  //         trans.get("alerts.reset_password_sended").subscribe((msg: string) =>{
  //           alert(msg);
  //         })
  //       }).catch(function(error) {
  //         // An error happened.
  //         alert(error);
  //         return false;
  //       });
  //     })
  // }

  resetPassword(userID: string) {
    let trans = this.translate
    var params = {}
    params['user'] = userID
    this.usersListSubs = this.dataService
      .resetPassword(params)
      .subscribe(res => {

        if (res == "success") {

          this.translate.get('alerts.reset_password_msg_success').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 })
          })

        } else {

          this.translate.get('alerts.reset_password_msg_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })

        }

      },
        console.error
      );
  }


  applyFilter(event: Event = null) {
    this.firstTime = false

    this.showUsersProgressBar = true
    // const filterValue = (event.target as HTMLInputElement).value;
    // this.dataSource.filter = filterValue.trim().toLowerCase();
    var params = {};
    params['page'] = 1
    params['size'] = this.pageSize
    params['role'] = this.filterForm.controls["role"].value;
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;
    
    this.pageIndex = 0
    this.paginator.pageIndex = 0

    
    this.dataService.getUsers(params).pipe(
      map((tableData: User) => this.dataSource = tableData)
    ).subscribe(() => this.showUsersProgressBar = false)

    this.dataService.getTotalUsers(params).pipe(
      map((totalItems) => this.totalItems = totalItems)
    ).subscribe()
  }

  newUser() {
    this.router.navigateByUrl(`user/new`);
  }

  saveUser() {
    var params = {};
    params['name'] = this.userForm.controls["name"].value;
    params['email'] = this.userForm.controls["email"].value;
    params['phone'] = this.userForm.controls["phone"].value;
    // params['password'] = this.userForm.controls["password"].value;
    params['id'] = this.userForm.controls["id"].value;
    params['role'] = this.userForm.controls["role"].value;
    params['manager'] = this.userForm.controls["manager"].value;

    if (params['name'] == '') {
      this.translate.get('alerts.name_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" });
      })
      return false;
    }
    if (params['email'] == '') {
      this.translate.get('alerts.email_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" });
      })
      return false;
    }

    if (params['role'] == '') {
      this.translate.get('alerts.role_required').subscribe((res: string) => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" });
      })
      return false;

    }

    this.dataService.saveUser(params).subscribe(data => {
      if (data['code'] == 200) {
        this.router.navigateByUrl(`users`);

      }
      else if (data['code'] == 201) {
        this.resetPassword(data['id'])
        // this.firebase.sendPasswordResetEmail(data['text']).then(function() {
        //   // Email send
        // }).catch(function(error) {
        //   // An error happened.
        //   alert(error);
        //   return false;
        // });
        this.router.navigateByUrl(`users`);
      }
      else {
        this.translate.get("alerts.user_exist").subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" });
          return false;

        })

      }
    }, error => {
      console.log(error);
    }
    )
  }

  delete(id_user: string) {
    var params = {};

    params['id'] = id_user;



    this.dataService.deleteUser(params).subscribe(data => {
      if (data == 'User deleted') {

        this.translate.get("alerts.user_deleted").subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 });
        })

        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate(['/users']));

        // this.router.navigateByUrl(`item/` + params['item']);
      }
      else {
        this.translate.get("alerts.user_deleted_error").subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000 });
        })
      }
    })

  }
  onPaginateChange(event: PageEvent) {


    this.showUsersProgressBar = true

    this.pageSize = event.pageSize
    var params = {};

    params['page'] = event.pageIndex + 1
    params['size'] = this.pageSize
    params['role'] = this.filterForm.controls["role"].value;
    params['search'] = (<HTMLInputElement>document.getElementById("input")).value;

    
    this.dataService.getUsers(params).pipe(
      map((tableData: User) => this.dataSource = tableData)
    ).subscribe(() => this.showUsersProgressBar = false)

    

    // let page = event.pageIndex;
    // let size = event.pageSize;

    // page = page + 1;

    // var params={};
    // params['catalogue'] = this.filterForm.controls["catalogue"].value;
    // params['theme'] = this.filterForm.controls["theme"].value;
    // params['page'] = page;
    // params['size'] = size;
    // this.dataService.getSchools(params).subscribe(schools => {
    //   this.schools = schools;
    //   this.dataSource.data = this.schools;

    //   // this.dataSource.filter = '';


    // });
  }

}
export class User {
  constructor(
    public name: string,
    public last_name: string,
    public email: string,
    public phone: string,
    public id: string,
    public role: string
  ) { }
}


// export interface TableData{
//   items: User[];
//   meta:{
//     totalSchools: number;
//     itemCount: number;
//     itemsPerPage: number;
//     totalPages: number;
//     currentPage: number;
//   },
//   links:{
//     first: string;
//     previous: string;
//     next: string;
//     last: string;
//   }
// }
